import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ProtectedRoute } from './components/auth/ProtectedRoute';
import { LoginScreen } from './screens/LoginScreen';
import { DashboardScreen } from './screens/DashboardScreen';
import { TransferScreen } from './screens/TransferScreen';
import { TopUpScreen } from './screens/TopUpScreen';
import { OrdersScreen } from './screens/OrdersScreen';
import { TransactionHistoryScreen } from './screens/TransactionHistoryScreen';
import { ProfileScreen } from './screens/ProfileScreen';
import { WalletDetailScreen } from './screens/WalletDetailScreen';
import { SendMoneyScreen } from './screens/SendMoneyScreen';
import { ReceiveMoneyScreen } from './screens/ReceiveMoneyScreen';
import { OrderPaymentScreen } from './screens/OrderPaymentScreen';
import { AdminLoginScreen } from './screens/admin/AdminLoginScreen';
import { AdminShell } from './screens/admin/AdminShell';
import { AdminRoute } from './components/admin/AdminRoute';
import { ScrollToTop } from './components/shared/ScrollToTop';
import './styles/global.css';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <ScrollToTop />
        <div className="App">
          <Routes>
            <Route path="/login" element={<LoginScreen />} />
            <Route path="/" element={<Navigate to="/dashboard" />} />
            
            {/* Protected Routes */}
            <Route path="/dashboard" element={
              <ProtectedRoute>
                <DashboardScreen />
              </ProtectedRoute>
            } />
            <Route path="/profile" element={
              <ProtectedRoute>
                <ProfileScreen />
              </ProtectedRoute>
            } />
            <Route path="/transactions" element={
              <ProtectedRoute>
                <TransactionHistoryScreen />
              </ProtectedRoute>
            } />
            <Route path="/orders" element={
              <ProtectedRoute>
                <OrdersScreen />
              </ProtectedRoute>
            } />
            <Route path="/transfer" element={
              <ProtectedRoute>
                <TransferScreen />
              </ProtectedRoute>
            } />
            <Route path="/top-up" element={
              <ProtectedRoute>
                <TopUpScreen />
              </ProtectedRoute>
            } />
            <Route path="/wallet/:walletType" element={
              <ProtectedRoute>
                <WalletDetailScreen />
              </ProtectedRoute>
            } />
            <Route path="/send-money" element={
              <ProtectedRoute>
                <SendMoneyScreen />
              </ProtectedRoute>
            } />
            <Route path="/receive-money" element={
              <ProtectedRoute>
                <ReceiveMoneyScreen />
              </ProtectedRoute>
            } />
            <Route path="/order-payment" element={
              <ProtectedRoute>
                <OrderPaymentScreen />
              </ProtectedRoute>
            } />

            {/* Admin Routes (separate token, gated server-side by isAdmin) */}
            <Route path="/admin/login" element={<AdminLoginScreen />} />
            <Route path="/admin" element={
              <AdminRoute>
                <AdminShell />
              </AdminRoute>
            } />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;